export default "__VITE_ASSET__CjlGEK_j__"